import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import { VISIBLE_PAGES } from '@/constants/labels';
import store from "@/store";

import LoginViewVue from '@/views/PrincipalHome/LoginView.vue';
import PageDown from '@/views/PrincipalHome/PageDownView.vue';
import VoidPageView from '@/views/PrincipalHome/VoidPageView.vue';
import PrincipalPageView from '@/views/PrincipalHome/PrincipalPageView.vue';
import DashBoardView from '@/views/SmartLink/Dashboard/DashBoardView.vue';
import TopologyStatsView from '@/views/SmartLink/Topo - Insta/TopologyStatsView.vue';
import AdminCSVView from '@/views/SmartLink/Admin/AdminCSVView.vue';
import AdminView from '@/views/SmartLink/Admin/AdminView.vue';
import DbStatus from '@/views/SmartLink/Admin/DBstatusview.vue';
import DBMaintenance from '@/views/SmartLink/Admin/DBmaintenance.vue';
import YAMLMaintenance from '@/views/SmartLink/Admin/YAMLMaintenance.vue';
// import KPIView from '@/views/SmartLink/KPI/KPIViewOld.vue';
import KPIView from '@/views/SmartLink/KPI/KPIView.vue';
import AllLatency from '@/views/SmartLink/KPI/AllLatencyView.vue';
import PredictView from '@/views/SmartLink/IA/PredictView.vue'
import PredictSNR from '@/views/SmartLink/IA/PredictSNRView.vue'
import ServerView from '@/views/SmartLink/Server - LTE/ServerView.vue';

import ReportView from '@/views/SmartLink/Report/ReportView.vue';
import ReportMap from '@/views/SmartLink/Report/ReportMap.vue';

import Drive from '@/views/SmartLink/Drive/DriveView.vue';
import DriveRAJANT from '@/views/SmartLink/Drive/DriveRajantView.vue';
import DriveHeatMap from '@/views/SmartLink/Drive/DriveHeatmapView.vue';
import DriveClientsView from '@/views/SmartLink/Drive/DriveClientsView.vue';

import BandWidth from '@/views/SmartLink/Drive/WidthBandView.vue';
import TestEO from '@/views/SmartLink/Test/Test-EO.vue';
import ColorSelectView from '@/views/PrincipalHome/ColorSelectView.vue';


import MonitorinView from '@/views/GestorHCGLink/MonitoringView.vue';
import ConfigurationView from '@/views/GestorHCGLink/Configurations/ConfigurationView.vue';
import StatisticsView from '@/views/GestorHCGLink/StatisticsView.vue';
import DashboardGestor from '@/views/GestorHCGLink/DashboardEjecutivoView.vue';
// import RaosPrincipalPage from '@/views/RAOS/RaosPrincipalPage.vue';
import ResetView from '@/views/SmartLink/Reset/ResetView.vue';


import TepeacaDashboardView from '@/views/Cementera/DashboardView.vue';
import TepeacaKPIView from '@/views/SmartLink/KPI/KPIView.vue';
import TepeacaAdministracionView from '@/views/SmartLink/Admin/AdminView.vue';
import TepeacaPlaybackView from '@/views/Cementera/PlaybackView.vue';
// import TepeacaKPIView from '@/views/Cementera/KpiView.vue';
// import TepeacaAdministracionView from '@/views/Cementera/AdministracionView.vue';

import MapRAOS from '@/components/RAOS/MapRAOS.vue';
import RaosKPI from '@/components/RAOS/Red/RaosKPI.vue';
import InicioView from '@/views/RAOS/InicioView.vue';
import AdminRAOSView from '@/views/RAOS/Management/AdminView.vue';
import TablaStatusRAOS from '@/components/RAOS/Status/TablaStatusRAOS.vue';
import ReportRAOSView from '@/views/RAOS/Report/ReportView.vue';


import EnergyView from '@/views/SmartLink/Energy/EnergyView.vue';


const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginViewVue,
    meta: { title: 'Inicio | SmartLink RAOS', layout: 'loginPage' }
  },
  {
    path: '/principalPage',
    name: 'Home',
    component: PrincipalPageView,
    meta: { layout: 'principalPage' }
  },

  { path: `/smartlink/${VISIBLE_PAGES.report}`, name: 'SmartLink-Report', component: ReportView },
  { path: `/smartlink/${VISIBLE_PAGES.servers}`, name: 'SmartLink-Servers', component: ServerView },
  { path: `/smartlink/${VISIBLE_PAGES.topology}`, name: 'SmartLink-Topology', component: TopologyStatsView },
  { path: `/smartlink/${VISIBLE_PAGES.predicts}`, name: 'SmartLink-PredictRX', component: PredictView },
  { path: `/smartlink/${VISIBLE_PAGES.admincsv}`, name: 'SmartLink-AdminCSV', component: AdminCSVView },
  { path: `/smartlink/${VISIBLE_PAGES.dbstatus}`, name: 'SmartLink-DBstatus', component: DbStatus },
  { path: `/smartlink/${VISIBLE_PAGES.dashboard}`, name: 'SmartLink-Dashboard', component: DashBoardView },
  { path: `/smartlink/${VISIBLE_PAGES.allLatency}`, name: 'SmartLink-AllLatency', component: AllLatency },
  { path: `/smartlink/${VISIBLE_PAGES.management}`, name: 'SmartLink-Admin', component: AdminView },
  { path: `/smartlink/${VISIBLE_PAGES.predictsnr}`, name: 'SmartLink-PredictSNR', component: PredictSNR },
  { path: `/smartlink/${VISIBLE_PAGES.dbmaintenance}`, name: 'SmartLink-DbMaintena', component: DBMaintenance },
  { path: `/smartlink/${VISIBLE_PAGES.YAMLMaintenance}`, name: 'SmartLink-YMLMaintena', component: YAMLMaintenance },


  { path: `/smartlink/${VISIBLE_PAGES.drive}`, name: 'SmartLink-Drive', component: Drive },
  { path: `/smartlink/${VISIBLE_PAGES.driverajant}`, name: 'SmartLink-DriveRajant', component: DriveRAJANT },
  { path: `/smartlink/${VISIBLE_PAGES.driveheatmap}`, name: 'SmartLink-DriveHeatMap', component: DriveHeatMap },
  { path: `/smartlink/${VISIBLE_PAGES.bandWidth}`, name: 'SmartLink-BandWidth', component: BandWidth },
  { path: `/smartlink/${VISIBLE_PAGES.driveClients}`, name: 'SmartLink-DriveClients', component: DriveClientsView },


  // { path: `/smartlink/kpiTest`, name: 'SmartLink-KPITEST', component: KPIViewTest },
  { path: `/smartlink/${VISIBLE_PAGES.kpi}`, name: 'SmartLink-KPI', component: KPIView },
  // { path: `/smartlink/${VISIBLE_PAGES.quality_snr}`, name: 'SmartLink-Quality_snr', component: KPIView },
  // { path: `/smartlink/${VISIBLE_PAGES.wiredpeers}`, name: 'SmartLink-Wiredpeers', component: KPIView },
  // { path: `/smartlink/${VISIBLE_PAGES.latency}`, name: 'SmartLink-Latency', component: KPIView },
  // { path: `/smartlink/${VISIBLE_PAGES.wirelesspeers}`, name: 'SmartLink-Wirelesspeers', component: KPIView },
  // { path: `/smartlink/${VISIBLE_PAGES.temp_inst}`, name: 'SmartLink-Temp_inst', component: KPIView },
  // { path: `/smartlink/${VISIBLE_PAGES.operability}`, name: 'SmartLink-Operability', component: KPIView },


  { path: `/smartlink/${VISIBLE_PAGES.monitoring}`, name: 'SmartLink-Monitoring', component: MonitorinView },
  { path: `/smartlink/${VISIBLE_PAGES.config}`, name: 'SmartLink-Configuration', component: ConfigurationView },
  { path: `/smartlink/${VISIBLE_PAGES.statistics}`, name: 'SmartLink-Statistics', component: StatisticsView },
  { path: `/smartlink/${VISIBLE_PAGES.gestorDash}`, name: 'SmartLink-Gestor-Dashboard', component: DashboardGestor },
  { path: `/smartlink/${VISIBLE_PAGES.reset}`, name: 'SmartLink-Reset', component: ResetView },


  { path: `/smartlink/cemex/${VISIBLE_PAGES.tepeaca.dashboard}`, name: 'SmartLink-Tepeaca-Dashboard', component: TepeacaDashboardView },
  { path: `/smartlink/cemex/${VISIBLE_PAGES.tepeaca.kpi}`, name: 'SmartLink-Tepeaca-KPI', component: TepeacaKPIView },
  { path: `/smartlink/cemex/${VISIBLE_PAGES.tepeaca.administracion}`, name: 'SmartLink-Tepeaca-Administracion', component: TepeacaAdministracionView },
  {
    path: `/smartlink/cemex/${VISIBLE_PAGES.tepeaca.playback}`,
    name: 'CementeraPlayback',
    component: TepeacaPlaybackView
  },




  { path: `/smartlinkRAOS/${VISIBLE_PAGES.raosinit}`, name: 'SmartLink-RAOSINIT', component: InicioView },
  // { path: `/smartlinkRAOS/${VISIBLE_PAGES.raospg}`, name: 'SmartLink-RaosPG', component: RaosPrincipalPage },
  { path: `/smartlinkRAOS/${VISIBLE_PAGES.raosmap}`, name: 'SmartLink-RaosMAP', component: MapRAOS },
  { path: `/smartlinkRAOS/${VISIBLE_PAGES.raoskpi}`, name: 'SmartLink-raosKPI', component: RaosKPI },
  { path: `/smartlinkRAOS/${VISIBLE_PAGES.raosstatus}`, name: 'SmartLink-RaosStatus', component: TablaStatusRAOS },
  { path: `/smartlinkRAOS/${VISIBLE_PAGES.raosmng}`, name: 'SmartLink-AdminRaosMng', component: AdminRAOSView },
  { path: `/smartlinkRAOS/${VISIBLE_PAGES.raosreport}`, name: 'SmartLink-RaosReport', component: ReportRAOSView },




  { path: `/smartlink/${VISIBLE_PAGES.energy}`, name: 'SmartLink-EnergyView', component: EnergyView },

  {
    path: '/maintenance',
    name: 'PageDown',
    component: PageDown,
    meta: { layout: 'maintenancePage' }
  },

  {
    path: '/reportMap',
    name: 'reportMap',
    component: ReportMap
  },

  { path: `/smartlink/test`, name: 'SmartLink-TEST', component: TestEO, },
  { path: `/smartlink/colors`, name: 'SmartLink-Color', component: ColorSelectView, },
]

const router = createRouter({
  history: createWebHashHistory('hola'),
  routes
})

router.beforeEach((to, from, next) => {
  const user = localStorage.getItem('user');
  const rol = localStorage.getItem('rol');

  // 1. Requiere sesión y no está logueado
  if (to.meta.requiresAuth && !user) {
    return next('/login');
  }

  // 2. Intenta ingresar a /principalPage sin ser desarrollador
  if (to.meta.role && to.meta.role !== rol) {
    return next(`/smartlink/${VISIBLE_PAGES.dashboard}`);
  }

  next();
});

// Sincroniza la barra de navegación al cambiar de ruta (incluyendo botones atrás/adelante)
router.afterEach((to) => {
  if (to.meta && to.meta.layout) {
    store.commit('setAppBarPage', to.meta.layout);
  } else if (to.path.startsWith('/smartlink')) {
    store.commit('setAppBarPage', 'smartlinkPage');
  }
});



export default router
